import React from 'react'

const PageContext = React.createContext({
    scale: '',
    change: '',
    animate: '',
});

export default PageContext;